import { GET_FURNITURE_RECIPES_SUCCESS } from "../actionTypes";

const initialState = []

export default function(state = initialState, action) {
  switch (action.type) {
    case GET_FURNITURE_RECIPES_SUCCESS: {
      const furnitureRecipes = action.payload;

      if (!furnitureRecipes){
        return {...state};
      }
      
      return [...state, ...action.payload]
    }

    default:
      return state;
  }
}
